import { render, staticRenderFns } from "./CollapseText.vue?vue&type=template&id=8d3a518e&scoped=true"
import script from "./CollapseText.vue?vue&type=script&lang=js"
export * from "./CollapseText.vue?vue&type=script&lang=js"
import style0 from "./CollapseText.vue?vue&type=style&index=0&id=8d3a518e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3a518e",
  null
  
)

export default component.exports